// extracted by mini-css-extract-plugin
export default {"prices":"prices_prices__iGbbZ","prices_skeleton":"prices_prices_skeleton__RsJoR","prices__regular":"prices_prices__regular__r91je"};